<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.4882 4.37798C12.5831 10.3593 10.2903 13.0162 2.88725 15.9265L7.61151 9.04985L0 0.0734863L10.0787 4.7454L12.479 2.41886C13.4135 2.03672 14.2349 2.04821 15.1457 2.13602C16.1033 3.7568 17.201 3.99356 20 4.37798H14.4882Z" fill="#009DD6"/>
</svg>
